export default (theme) => ({
    closeButton: {
        textAlign: "end",
    },
    listContainer: {
        width: "100%",
        maxHeight: "40vh",
        overflow: "auto",
    },
    modalBox: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        background: "#fff",
        borderRadius: `${theme.spacing(1)}`,
        padding: `${theme.spacing(1)}`,
        width: "90%",
    },
    modalMessage: {
        whiteSpace: "break-spaces",
        textAlign: "justify",
        margin: theme.spacing(1),
    },
});
